module.exports = __webpack_public_path__ + "static/media/Digital_Thread.414206e9.svg";